import Button from '@storeblocks/button';
import { useFormikContext } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router';

import { InsuranceDetails } from 'Api/insurance';
import { getAppText } from 'Utils/text';
import { ButtonContainer } from '../cancelForm.styles';
import { EmailCancellationFormValues } from './emailCancellationForm.values';

interface EmailCancellationFormButtonsProps {
  insuranceProduct: InsuranceDetails['insuranceProduct'];
  submitSuccess: boolean;
}

export const EmailCancellationFormButtons = ({
  insuranceProduct,
  submitSuccess,
}: EmailCancellationFormButtonsProps) => {
  const navigate = useNavigate();

  const { isSubmitting, submitCount, isValid } =
    useFormikContext<EmailCancellationFormValues>();

  return (
    <ButtonContainer>
      {!submitSuccess && (
        <Button
          type="submit"
          data-trackid={`button-send_message_cancel_insurance_${insuranceProduct}`}
          loading={isSubmitting}
          disabled={submitCount > 0 && !isValid}
        >
          {getAppText('cancelInsurance.manualMessage.submit.button.label')}
        </Button>
      )}

      <Button
        data-trackid={`button-go_back_cancel_insurance_${insuranceProduct}`}
        iconLeft="arrow-left"
        variant="text"
        onClick={() => navigate(-1)}
      >
        {getAppText('cancelInsurance.button.goBack')}
      </Button>
    </ButtonContainer>
  );
};
